/** Zenn の published_at（ISO 文字列）を表示用の日時にする */
export const formatDate = (timeStampString: string) =>
  new Date(timeStampString).toLocaleString();
